import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'app-contractors',
  templateUrl: './contractors.component.html',
})
export class ContractorsComponent implements OnInit {
  public contractors: any[];

  public routeRole: any;
  public errorAlerts;

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  public defaultSortField = 'name';
  private selectedSort = [this.defaultSortField + ',asc'];

  public isFilterLoading: boolean;
  private filterTextCompanyName: string = '';

  public createCompanyModal = false;
  public createCompanyForm: FormGroup;

  constructor(
    private contractorService: ContractorService,
    private notificationService: NotificationService,
    private router: Router,
    private globals: Globals,
    private fb: FormBuilder,
  ) {
    this.routeRole = globals.user.routeRole;

    this.createCompanyForm = fb.group({
      name: new FormControl('', [Validators.required]),
      additionalInfo: new FormControl(''),
    });
  }

  ngOnInit() {
    this.resetPagination();
  }

  private getAllContractors() {
    this.contractorService.getAllContractors(this.pagination, this.selectedSort, [{ key: 'filter', value: this.filterTextCompanyName }]).subscribe((data: any) => {
      this.contractors = data.body;
      this.contractors.forEach(contractor => {
        contractor.manager = contractor.maintenanceManager ? contractor.maintenanceManager.firstName + ' ' + contractor.maintenanceManager.lastName : null;
      });

      this.pagination.totalRecords = data.totalRecords;
      this.isFilterLoading = false;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving worker list');
      this.isFilterLoading = false;
    });
  }

  public onRowSelect(event) {
    this.router.navigate(['/' + this.routeRole + '/contractors', event.data.id]);
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllContractors();
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };

    this.goToFirstPage();

    this.getAllContractors();
  }

  public createNewCompany() {
    this.toggleCreateCompanyModal();
  }

  public toggleCreateCompanyModal() {
    this.createCompanyModal = !this.createCompanyModal;
  }

  public onCreateCompanyFormSubmit() {
    const value = this.createCompanyForm.value;

    this.contractorService.createContractor(value).subscribe((data: any) => {
      this.createCompanyForm.reset();
      this.toggleCreateCompanyModal();
      this.getAllContractors();
      this.notificationService.notify('success', 'Contractor Created!');
    });
  }

  public onFilterTextChangedCompany(filterText: string) {
    this.isFilterLoading = true;
    this.filterTextCompanyName = filterText;

    this.goToFirstPage();
    this.getAllContractors();
  }

  public customSort(sort: SortEvent) {
    let sortDirection: String = 'asc';

    if (sort.order === -1) {
      sortDirection = 'desc';
    }
    this.selectedSort = [sort.field + ',' + sortDirection];

   this.goToFirstPage();

    this.getAllContractors();
  }

    private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
